
const app_env = import.meta.env.MODE;
export const apiEndPoint = app_env?.trim() === 'development' ?
    'http://localhost:8080/' :
    // "http://excelforceapi.datavanced.com/" :
    app_env?.trim() === 'test' ?
        "https://excelforcev3-beta.azurewebsites.net/" :
        "https://excelforcev3.azurewebsites.net/";

export const BILLING_CATEGORIES = [
    "",
    "ACA Manager™",
    "CMS Staffing Data Submission",
    "EverythingBenefits",
    "HR",
    "HRAnswerLink SSO",
    "Labor Posters",
    "PR",
    "SMS Integration with Twilio",
    "TLM"
];

export const ipInfoToken = "71c5138d120c74";

export const weekDays = [
    "Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"
];

export const shortMonths = [
    "jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
];

export const timeFrames = () => {
    let hours, minutes, ampm;
    let times = [];
    for (let i = 0; i <= 1425; i += 15) {
        hours = Math.floor(i / 60);
        minutes = i % 60;
        if (minutes < 10) {
            minutes = "0" + minutes; // adding leading zero
        }
        ampm = hours % 24 < 12 ? "AM" : "PM";
        hours = hours % 12;
        if (hours === 0) {
            hours = 12;
        };
        times.push({ label: `${hours}:${minutes} ${ampm}`, value: i });
    };
    return times;
}

export const numberedWeekDays = [
    { label: "Sunday", value: 0 },
    { label: "Monday", value: 1 },
    { label: "Tuesday", value: 2 },
    { label: "Wednesday", value: 3 },
    { label: "Thursday", value: 4 },
    { label: "Friday", value: 5 },
    { label: "Saturday", value: 6 }
];

export const formatFile = [
    "pdf", "csv"
];
export const dateFrequency = [
    "Daily", "Weekly", "Monthly", "Quarterly"
];

export const weekDaysNew = [
    { "day": "Sunday", "isActive": false },
    { "day": "Monday", "isActive": false },
    { "day": "Tuesday", "isActive": false },
    { "day": "Wednesday", "isActive": false },
    { "day": "Thursday", "isActive": false },
    { "day": "Friday", "isActive": false },
    { "day": "Saturday", "isActive": false },
];

export const clientPermissionsList = [
    {
        key: "CERTIFIED_PAYROLL",
        label: "Certified Payroll",
        group: "REPORTS"
    },
    {
        key: "COUNTERS_TE_REPORT",
        label: "Counters TE Report",
        group: "REPORTS"
    },
    {
        key: "NJ_CERTIFIED",
        label: "NJ Certified Payroll",
        group: "REPORTS"
    },
    {
        key: "DIRECT_DEPOSIT_TOOL",
        label: "Direct Deposit tool",
        group: "TOOLS"
    },
    {
        key: "EMAIL_SETUP",
        label: "Email Schedule",
        group: "TOOLS"
    },
    {
        key: "EMPLOYEES_ACCRUALS",
        label: "Employee Accrual Totals",
        group: "REPORTS"
    },
    {
        key: "EMPLOYEE_LOCK_PREVENTION",
        label: "Employee Lock Prevention",
        group: "AUTOMATED TASKS"
    },
    {
        key: "PATIENT_HOURS",
        label: "Patient Hours",
        group: "REPORTS"
    },
    {
        key: "PAYROLL_DEDUCTION_COMPARISON",
        label: "Deduction Comparison",
        group: "REPORTS"
    },
    {
        key: "PAYROLL_DISTRIBUTION_COMPARISON",
        label: "Payroll Comparison",
        group: "REPORTS"
    },
    {
        key: "SCHEDULER_REPORTS",
        label: "Scheduler Reports",
        group: "REPORTS"
    },
    {
        key: "401K_ADJUSTMENT",
        label: "401K Adjustment",
        group: "REPORTS"
    },
    {
        key: "SCHEDULED_DEDUCTIONS",
        label: "Schedule Deductions",
        group: "AUTOMATED TASKS"
    },
    {
        key: "SOH_TOOL",
        label: "Spread of hours tool",
        group: "TOOLS"
    },
    {
        key: "TURNOVER_RATE",
        label: "Turnover Rate",
        group: "REPORTS"
    },
    {
        key: "WAGE_PARITY",
        label: "Wage Parity",
        group: "REPORTS"
    },
    {
        key: "PPD_CENSUS_DATA",
        label: "PPD Reports",
        group: "REPORTS"
    }
];

export const reports = [
    { "Key": "PATIENT_HOURS", "Value": "Patient Hours", },
    { "Key": "WAGE_PARITY", "Value": "Wage Parity" },
    { "Key": "CERTIFIED_PAYROLL", "Value": "Certified Payroll", },
    { "Key": "EMPLOYEES_ACCRUALS", "Value": "Employees Accruals", }
];

export const tableTemplates = [
    {
        value: "nycnpssg",
        label: "NYC NonPublic Schools Security Service"
    },
    {
        value: "nycgf",
        label: "NYC General Certified Payroll Form"
    },
    {
        value: "njwh",
        label: "New Jersey Wage Hub"
    }
];

export const tradeClassSources = [
    {
        value: "ccInfo",
        label: "Cost Center"
    },
    {
        value: "empInfo",
        label: "Employee Custom Field"
    }
];

export const UKG_BILLING_ITEMS = [
    "Payroll: Partner Billing Wholesale 3 - No Historical",
    "Email Reports (Monthly Fee)",
    "Document Storage (Monthly Fee)",
    "Document Upload/Download (Monthly Fee)",
    "SOAP Calls (Monthly Fee)",
    "SOAP Transfer (Monthly Fee)",
    "Talent Acquisition (Recruitment)",
    "Holding / Parent Company",
    "E-Verify",
    "ACA Manager",
    "Leave of Absence Monthly Billing",
    "Monthly HR Enterprise GF w/Min",
    "Monthly Scheduler Billing",
    "Payroll: Partner Billing Wholesale 3 - Historical Only",
    "People Analytics",
    "Google Cloud G Suite Integration",
    "Learning Center",
    "TLM MME170 W/25Min-EL",
    "HR Enterprise170 W/Min-EL",
    "TLM LITE2 55 W/18Min-EL",
    "TLM MME050 Promo",
    "HR Enterprise050 Promo",
    "Renewal InTouch 9000, Standard Maintenance Coverage",
    "Renewal Touch ID InTouch, Standard Maintenance Coverage",
    "Renewal InTouch DX, Standard Maintenance Coverage",
    "Renewal InTouch DX Touch ID, Standard Maintenance Coverage",
]